import {connect, useDispatch, useSelector} from "react-redux"
import {createPortal} from "react-dom"
import Robot from "../Robot/robot"
import React, {CSSProperties, useEffect, useRef, useState} from "react"
import Styles from "./cqRobot.less"
import {useBoolean, useDebounceFn} from "ahooks"
import activeXiaoK from "./image/xiaoK.png"
import inActiveXiaoK from "./image/xiaoK2.png"
import {State} from "../../store/store"
import {CardClickAction, CardClickActionData} from "../Card/card"
import useUpdateLoadingStatus from "./share/useUpdateLoadingStatus"
import {Rnd} from "react-rnd"
import {EvaluationData} from "../Evaluation/evaluation"
import classNames from "classnames"
import {func} from "prop-types"
import FpIframe from "../fpIframe/fpIframe"
import {checkErrResponse} from "../../utils/util"
import {isEmpty} from "lodash-es"

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps
const ErrorCode = -1

const RobotSize = {
    ADAPTWIN: {
        width: "100%",
        height: "100%",
        margin: 0,
    },
    FULL_SCREEN: {
        width: 800,
        height: 500,
    },
    WINDOW: {
        width: 400,
        height: 629,
    },
}

const RobotYAxisOffset = 50

const CqRobot: React.FC<Props> = ({
    dialogList,
    sessionId,
    serverHost,
    appId,
    welcome,
    newPortal,
    adaptWindow,
    showInContainer,
    model,
    addNewInput,
    addNewAnswer,
    fpInvokeData,
    showFpType,
    disableDraggingStatus,
    enableDraggingStatus,
}) => {
    const [display, displayAction] = useBoolean(false)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const handleSubmitPJInfo = async (data: any) => {
        setLoading(true)
        let invoiceList: Array<string> = []
        const eventData = JSON.parse(data.eventData)
        Object.keys(data).forEach((key) => {
            if (data[key] === "true" && typeof data[key] === "string") {
                invoiceList.push(key)
            }
        })

        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                "sessionId": sessionId,
                "buttonClick": {
                    eventType: data.eventType,
                    eventData: {
                        ...eventData,
                        setParam: {
                            ...eventData.setParam,
                            submit: {
                                ...eventData.setParam.submit,
                                [`invoceId`]: invoiceList.join(","),
                            },
                        },
                    },
                },
                "pageIndex": 0,
            }),
        })
        let res = await response.json()
        setLoading(false)
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res?.errorCode === ErrorCode) {
            setLoading(false)
            addNewAnswer({
                data: {
                    title: res.error,
                },
            })
            return
        }
        if (res?.data === null) {
            setLoading(false)
            return
        } else {
            if (
                res.data.dataList &&
                res.data.dataList.length !== 0 &&
                res.data.dataList[0].cardListJson &&
                res.data.dataList[0].cardListJson.length !== 0
            ) {
                let cardActionData = JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction
                    ? JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction.data
                    : null
                if (cardActionData) {
                    if (cardActionData.eventType === "openFP") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "FP",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    eventData: JSON.stringify({
                                        setParam: {
                                            billId: cardActionData.data.billId,
                                            invoceId: "",
                                        },
                                        itemClick: "根据现有信息生成差旅报销单",
                                    }),
                                    eventType: "setParam|itemClick",
                                },
                            },
                        })
                        return
                    }
                    if (cardActionData.eventType === "openPJ") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "PJ",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    "eventData": "重新进入票夹查找一遍发票",
                                    "eventType": "itemClick",
                                },
                            },
                        })
                        return
                    }
                }
            }
        }
        addNewAnswer(res)
    }
    const handleParam = async (data: any) => {
        setLoading(true)
        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({"sessionId": sessionId, "buttonClick": {...data}, "pageIndex": 0}),
        })
        let res = await response.json()
        setLoading(false)
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res?.errorCode === ErrorCode) {
            setLoading(false)
            addNewAnswer({
                data: {
                    title: res.error,
                },
            })
            return
        }
        if (res?.data === null) {
            setLoading(false)
            return
        } else {
            if (
                res.data.dataList &&
                res.data.dataList.length !== 0 &&
                res.data.dataList[0].cardListJson &&
                res.data.dataList[0].cardListJson.length !== 0
            ) {
                let cardActionData = JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction
                    ? JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction.data
                    : null
                if (cardActionData) {
                    if (cardActionData.eventType === "openFP") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "FP",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    eventData: JSON.stringify({
                                        setParam: {
                                            billId: cardActionData.data.billId,
                                            invoceId: "",
                                        },
                                        itemClick: "根据现有信息生成差旅报销单",
                                    }),
                                    eventType: "setParam|itemClick",
                                },
                            },
                        })
                        return
                    }
                    if (cardActionData.eventType === "openPJ") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "PJ",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    "eventData": "重新进入票夹查找一遍发票",
                                    "eventType": "itemClick",
                                },
                            },
                        })
                        return
                    }
                }
            }
        }
        addNewAnswer(res)
    }
    const handleInput = async (data: any) => {
        if (!(data.show === false)) {
            addNewInput(data.eventData)
        }

        setLoading(true)

        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({"sessionId": sessionId, "message": data.eventData, "pageIndex": 0}),
        })
        let res = await response.json()
        setLoading(false)
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res?.errorCode === ErrorCode) {
            setLoading(false)
            addNewAnswer({
                data: {
                    title: res.error,
                },
            })
            return
        }
        if (res?.data === null) {
            setLoading(false)
            return
        } else {
            if (
                res.data.dataList &&
                res.data.dataList.length !== 0 &&
                res.data.dataList[0].cardListJson &&
                res.data.dataList[0].cardListJson.length !== 0
            ) {
                let cardActionData = JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction
                    ? JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction.data
                    : null
                if (cardActionData) {
                    if (cardActionData.eventType === "openFP") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "FP",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    eventData: JSON.stringify({
                                        setParam: {
                                            billId: cardActionData.data.billId,
                                            invoceId: "",
                                        },
                                        itemClick: "根据现有信息生成差旅报销单",
                                    }),
                                    eventType: "setParam|itemClick",
                                },
                            },
                        })
                        return
                    }

                    if (cardActionData.eventType === "openPJ") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "PJ",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    "eventData": "重新进入票夹查找一遍发票",
                                    "eventType": "itemClick",
                                },
                            },
                        })
                        return
                    }
                }
            }
        }
        addNewAnswer(res)
    }
    const handleSubmitFpData = async (invoiceSerialNos: any) => {
        setLoading(true)
        let invokeData = fpInvokeData
        if (showFpType === "FP") {
            let eventData = JSON.parse(fpInvokeData.eventData)
            eventData.setParam.invoceId = invoiceSerialNos
            invokeData = {
                eventData,
                eventType: "setParam|itemClick",
            }
        }
        dispatch({
            type: "showFpIframe",
            payload: {status: false, type: "FP", param: {}, fpInvokeData: ""},
        })
        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                "sessionId": sessionId,
                "buttonClick": {
                    ...invokeData,
                    "showLoading": true,
                    "showSelectTEXT": false,
                },
            }),
        })
        let res = await response.json()
        setLoading(false)
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res?.errorCode === ErrorCode) {
            setLoading(false)
            addNewAnswer({
                data: {
                    title: res.error,
                },
            })
            return
        }
        if (res?.data === null) {
            setLoading(false)
            return
        } else {
            if (
                res.data.dataList &&
                res.data.dataList.length !== 0 &&
                res.data.dataList[0].cardListJson &&
                res.data.dataList[0].cardListJson.length !== 0
            ) {
                let cardActionData = JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction
                    ? JSON.parse(res.data.dataList[0].cardListJson[0]).selectAction.data
                    : null
                if (cardActionData) {
                    if (cardActionData.eventType === "openFP") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "FP",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    eventData: JSON.stringify({
                                        setParam: {
                                            billId: cardActionData.data.billId,
                                            invoceId: "",
                                        },
                                        itemClick: "根据现有信息生成差旅报销单",
                                    }),
                                    eventType: "setParam|itemClick",
                                },
                            },
                        })
                        return
                    }

                    if (cardActionData.eventType === "openPJ") {
                        if (isEmpty(cardActionData.data)) {
                            return
                        }
                        dispatch({
                            type: "showFpIframe",
                            payload: {
                                status: true,
                                type: "PJ",
                                param: cardActionData.data,
                                fpInvokeData: {
                                    "eventData": "重新进入票夹查找一遍发票",
                                    "eventType": "itemClick",
                                },
                            },
                        })
                        return
                    }
                }
            }
        }
        addNewAnswer(res)
    }
    const handleCardClick = (param: CardClickAction) => {
        let url = param.url
        if (url !== null && url !== undefined) {
            if (url.startsWith("bizAction://")) {
                // @ts-ignore
                // if (url.startsWith("bizAction://showFPInterface?")) {
                //     let fpData = JSON.parse(url.replace("bizAction://showFPInterface?", ""))
                //     if (isEmpty(fpData)) {
                //         return
                //     }
                //     dispatch({
                //         type: "showFpIframe",
                //         payload: {status: true, param: fpData, fpInvokeData: param.data},
                //     })
                // } else {
                invokeUrl(url)
                // }
            } else {
                window.open(url)
            }
            return
        }

        if (param?.data?.eventType == null) {
            console.warn("卡片没有点击事件")
            return
        }
        switch (param.data.eventType) {
            case "guideItemClick":
                handleBtnClick(param.data)
                return
            case "btnClick":
                handleBtnClick(param.data)
                return
            // case "CQ_FAPIAO":
            //     handleOpenFaPiao()
            //     return
            // case "invoice-intent":
            //     // @ts-ignore
            //     let fpData = JSON.parse(param.data.url.replace("bizAction://showFPInterface?", ""))
            //     console.log(fpData)
            //     if (isEmpty(fpData)) {
            //         return
            //     }
            //     dispatch({
            //         type: "showFpIframe",
            //         payload: {status: true, param: fpData, fpInvokeData: param.data},
            //     })
            //     return
            case "thirdPlatformAction":
                model.invoke("showSearchResultForm", param.data.eventData)
                loadingStatus.toLoading()
                displayAction.setFalse()
                return
            case "itemClick":
                handleInput(param.data)
                return
            case "setParam|itemClick":
                if (JSON.parse(param.data.eventData).type === "submitPJInfo") {
                    handleSubmitPJInfo(param.data)
                } else {
                    handleParam(param.data)
                }
                return
            default:
                console.warn("尚未支持该类型卡片点击事件", param.data)
                return
        }
    }

    useEffect(() => {
        if (sessionId != null) {
            handleGetGuideData()
        }
        // handleOpenFaPiao()
    }, [sessionId])

    const handleGetGuideData = async () => {
        const response = await fetch(`${serverHost}/chatbot/getmainpagedata`, {
            method: "POST",
            body: JSON.stringify({
                "sessionId": sessionId,
                "deviceObjectType": "CQ_CHATBOT",
                "appid": appId,
                "pagination": {
                    "pageSize": 4,
                    "current": 1,
                    "total": 0,
                },
            }),
        })
        const res = await response.json()
        const data = res.data
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (Array.isArray(data) !== true || data.length === 0) {
            console.error("web小K获取引导列表失败")
            return
        }
        addNewAnswer({
            data: {
                title: welcome,
                cardListJson: [JSON.stringify(res.data[0])],
            },
        })
    }

    const handleBtnClick = async (data: CardClickActionData) => {
        setLoading(true)

        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "sessionId": sessionId,
                "buttonClick": data,
            }),
        })
        const res = await response.json()
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res?.errorCode === ErrorCode) {
            setLoading(false)
            addNewAnswer({
                data: {
                    title: res.error,
                },
            })
            return
        }

        if (res?.data === null) {
            setLoading(false)
            return
        }

        let autoJumpUrl = res?.data?.autoJumpUrl
        // 点击按钮之后触发自动跳转

        if (autoJumpUrl != null && String(autoJumpUrl).startsWith("bizAction://")) {
            invokeUrl(autoJumpUrl)
        } else if (autoJumpUrl != null && String(autoJumpUrl).includes("://")) {
            displayAction.setFalse()
            window.open(autoJumpUrl)
        }
        //  else if (autoJumpUrl != null && String(autoJumpUrl).startsWith("https://")) {
        //     displayAction.setFalse()
        //     window.open(autoJumpUrl)
        // }
        setLoading(false)
        addNewAnswer(res)
    }

    const handleGetFPData = async (data: any) => {
        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "sessionId": sessionId,
                "buttonClick": data,
            }),
        })
    }

    const loadingStatus = useUpdateLoadingStatus()

    const invokeUrl = (url?: string) => {
        if (url == null) {
            return
        }
        displayAction.setFalse()
        const b = url.substring(url.indexOf("bizAction://") + 12)
        const key = b.substring(0, b.indexOf("?"))
        const value = b.substring(b.indexOf("?") + 1)
        model.invoke(key, value)
        loadingStatus.toLoading()
    }

    const handleResetSession = async () => {
        const response = await fetch(`${serverHost}/chatbot/clearSession?sessionId=${sessionId}`)
        const res = await response.json()
        const isOldErr = checkErrResponse(res)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: res.msg,
                },
            })
            return
        }
        if (res.success === true) {
            await handleGetGuideData()
        }
    }

    const isFullScreen = useRef(true)
    const setIsFullScreen = (value: boolean) => {
        isFullScreen.current = value
    }

    const bgStyle: CSSProperties = {
        display: display ? "block" : "none",
        pointerEvents: isFullScreen.current ? "auto" : "none",
        backgroundColor: isFullScreen.current ? "rgba(0, 0, 0, 0.5)" : "",
    }

    const maskRef = useRef<HTMLDivElement>(null)
    const handleMuskClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === maskRef.current) {
            displayAction.setFalse()
        }
    }

    const handleExit = () => {
        displayAction.setFalse()
    }

    const getEntryImage = () => {
        return entryActive ? activeXiaoK : inActiveXiaoK
    }

    const handleImgClick = () => {
        if (sessionId == null || sessionId.length === 0) {
            model.invoke("newChatbotSession", undefined)
        }
        displayAction.toggle()
    }

    const handleWeltClick = () => {
        setIsFullScreen(!isFullScreen.current)
        resetPosition()
    }

    const resetPosition = () => {
        if (!isFullScreen.current) {
            setPositionProxy({
                x: window.innerWidth - RobotSize.WINDOW.width,
                y: window.innerHeight - RobotSize.WINDOW.height - RobotYAxisOffset,
            })
        } else {
            setPositionProxy({
                x: (window.innerWidth - RobotSize.FULL_SCREEN.width) / 2,
                y: (window.innerHeight - RobotSize.FULL_SCREEN.height) / 2 - RobotYAxisOffset,
            })
        }
    }

    const {run: debouncedResetPosition} = useDebounceFn(resetPosition, {wait: 300})

    useEffect(() => {
        //  仅在窗口被遮挡住的时候，才重新调整位置
        const handleResize = () => {
            let dot4 = {
                x: position.x + RobotSize.FULL_SCREEN.width,
                y: position.y + RobotSize.FULL_SCREEN.height + RobotYAxisOffset,
            }
            if (!isFullScreen.current) {
                dot4 = {
                    x: position.x + RobotSize.WINDOW.width,
                    y: position.y + RobotSize.WINDOW.height + RobotYAxisOffset,
                }
            }

            if (dot4.x > window.innerWidth || dot4.y > window.innerHeight) {
                debouncedResetPosition()
            }
        }

        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    })

    const [entryActive, setEntryActive] = useBoolean(false)

    const [position, setPosition] = useState({
        x: 0,
        y: 0,
    })

    const setPositionProxy = (param: {x: number; y: number}) => {
        setPosition(param)
    }

    const disableDragging = useSelector((state: State) => state.disableDragging)

    useEffect(() => {
        setPositionProxy({
            x: (window.innerWidth - RobotSize.FULL_SCREEN.width) / 2,
            //  垂直居中时，Y轴稍微往上一点
            y: (window.innerHeight - RobotSize.FULL_SCREEN.height) / 2 - RobotYAxisOffset,
        })
    }, [])
    const handleAddEvaluated = async (data: EvaluationData) => {
        addNewAnswer({
            data: {
                title: data.praise ? "感谢反馈，很高兴可以帮到你。" : "你的反馈我已收到，后续会继续改进。",
            },
        })

        const EvaluationType = {
            YES: "faq-feedback-yes",
            NO: "faq-feedback-no",
        }

        const sendData = {
            "sessionId": sessionId,
            "buttonClick": {
                "eventData": data.id,
                "eventType": data.praise ? EvaluationType.YES : EvaluationType.NO,
            },
        }

        const response = await fetch(`${serverHost}/chatbot/v2/chat`, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(sendData),
        })
        const result = await response.json()
        const isOldErr = checkErrResponse(result)
        if (isOldErr) {
            addNewAnswer({
                data: {
                    title: result.msg,
                },
            })
            return
        }
    }
    const sizeStyle = adaptWindow ? RobotSize.ADAPTWIN : isFullScreen.current ? RobotSize.FULL_SCREEN : RobotSize.WINDOW
    let newEntryClassName = classNames(Styles["newEntry"], "kdfont kdfont-duihua3")
    let oldEntryClassName = classNames(Styles["oldEntry"], "kdfont kdfont-duihua3")
    const newWrapper = () => {
        return (
            <div
                onMouseEnter={() => setEntryActive.setTrue()}
                onMouseLeave={() => setEntryActive.setFalse()}
                onClick={handleImgClick}
                id={"entryBox"}
                className={Styles["entryBox"]}
                title={"小K"}
            >
                <i className={newEntryClassName} />
            </div>
        )
    }
    const oldWrapper = () => {
        return (
            <div
                onMouseEnter={() => setEntryActive.setTrue()}
                onMouseLeave={() => setEntryActive.setFalse()}
                onClick={handleImgClick}
                id={"oldEntryBox"}
                className={Styles["oldEntryBox"]}
            >
                <i className={oldEntryClassName} />
            </div>
        )
    }

    if (showInContainer) {
        return (
            <Robot
                style={sizeStyle}
                className={classNames(Styles["robot"], "kd-cq-custom-nlp-xiao-k-ctrl", {
                    [Styles["in-container"]]: showInContainer,
                })}
                adaptWindow
                dialogList={dialogList}
                isActive={display}
                isFullScreen={isFullScreen.current}
                isLoading={loading}
                enableDraggingStatus={enableDraggingStatus}
                disableDraggingStatus={disableDraggingStatus}
                onInput={handleInput}
                onEvaluated={handleAddEvaluated}
                onExit={handleExit}
                onCardClick={handleCardClick}
                onResetSession={handleResetSession}
                onWeltClick={handleWeltClick}
            />
        )
    }
    return (
        <div style={{width: "100%", height: "100%", color: `#666`}}>
            {adaptWindow ? null : newPortal ? newWrapper() : oldWrapper()}
            <FpIframe onSubmit={handleSubmitFpData} />
            {adaptWindow ? (
                <Robot
                    style={sizeStyle}
                    className={Styles["robot"]}
                    adaptWindow={adaptWindow}
                    dialogList={dialogList}
                    isActive={display}
                    isFullScreen={isFullScreen.current}
                    isLoading={loading}
                    enableDraggingStatus={enableDraggingStatus}
                    disableDraggingStatus={disableDraggingStatus}
                    onInput={handleInput}
                    onEvaluated={handleAddEvaluated}
                    onExit={handleExit}
                    onCardClick={handleCardClick}
                    onResetSession={handleResetSession}
                    onWeltClick={handleWeltClick}
                />
            ) : (
                createPortal(
                    <div ref={maskRef} className={Styles["mask"]} style={bgStyle} onClick={handleMuskClick}>
                        <Rnd
                            position={position}
                            onDragStop={(e, d) => setPositionProxy({x: d.x, y: d.y})}
                            style={{pointerEvents: "auto"}}
                            enableResizing={false}
                            disableDragging={isFullScreen.current || disableDragging}
                            bounds={"window"}
                        >
                            <Robot
                                style={sizeStyle}
                                className={Styles["robot"]}
                                dialogList={dialogList}
                                isActive={display}
                                isFullScreen={isFullScreen.current}
                                adaptWindow={adaptWindow}
                                isLoading={loading}
                                enableDraggingStatus={enableDraggingStatus}
                                disableDraggingStatus={disableDraggingStatus}
                                onInput={handleInput}
                                onEvaluated={handleAddEvaluated}
                                onExit={handleExit}
                                onCardClick={handleCardClick}
                                onResetSession={handleResetSession}
                                onWeltClick={handleWeltClick}
                            />
                        </Rnd>
                    </div>,
                    document.body
                )
            )}
        </div>
    )
}

const mapStateToProps = (state: State) => ({
    dialogList: state.dialogList,
    appId: state.appId,
    sessionId: state.sessionId,
    welcome: state.welcome,
    serverHost: state.serverHost,
    adaptWindow: state.adaptWindow,
    fpInvokeData: state.fpInvokeData,
    showFpType: state.showFpType,
    model: state.model,
    newPortal: state.newPortal,
    showInContainer: state.showInContainer,
})

const mapDispatchToProps = {
    addNewInput: (inputText: string) => ({
        type: "addNewInput",
        payload: {
            text: inputText,
        },
    }),
    addNewAnswer: (data: any) => ({
        type: "addNewAnswer",
        payload: data,
    }),
    enableDraggingStatus: () => ({
        type: "updateDraggingState",
        payload: false,
    }),
    disableDraggingStatus: () => ({
        type: "updateDraggingState",
        payload: true,
    }),
}

export default connect(mapStateToProps, mapDispatchToProps)(CqRobot)

console.log("AWXK: <AWXK_TIME_STAMP>")
